import type React from 'react'
import type { PropsWithChildren } from 'react'

import { BodyXS } from '@/components/atomic/text'

interface ModelBucketWeightLegendProps {
  text: string
}

export const ModelBucketWeightLegend: React.FC<
  ModelBucketWeightLegendProps
> = ({ text }) => (
  <div className="flex items-center gap-2 mt-[4px]">
    <div className="h-[8px] w-[8px] bg-reference-area-background rounded-[2px]"></div>
    <BodyXS color="text-secondary" asChild>
      <span>{text}</span>
    </BodyXS>
  </div>
)

export const ModelBucketRowContainer: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="grid grid-cols-2 gap-4">{children}</div>

export const ModelBucketWidthCustomContainer: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="flex gap-4 pt-2">{children}</div>

export const ModelBucketWidthInputContainer: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <div className="w-full flex gap-2 items-center [&>:last-child]:w-40">
    {children}
  </div>
)

export const ModelMaturitySlider: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="mt-[19px]">{children}</div>

export const ModelBucketWeightHeader: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="flex gap-4">{children}</div>

export const ModelConstraintBucketWeightContainer: React.FC<
  PropsWithChildren
> = ({ children }) => <div className="h-[270px]">{children}</div>

export const ModelConstraintBucketWeightInputContainer: React.FC<
  PropsWithChildren
> = ({ children }) => <div className="max-w-[180px]">{children}</div>
